import { AiFillAppstore } from "react-icons/ai";
import { FaMobile, FaGlobe} from "react-icons/fa";
import { SiProgress, SiAntdesign } from "react-icons/si";

// Features Data
export const featuresData = [
  {
    id: 1,
    title: "Business Stratagy",
    des: "Strategic planning aligns goals, resources, and adaptability for business growth, resilience, and competitive success.",
  },
  {
    id: 2,
    icon: <AiFillAppstore />,
    title: "Web Development",
    des: "HTML, CSS, and JavaScript. Adept at creating responsive and visually appealing websites. Skilled in backend technologies like Node.js and Express",
  },
  {
    id: 3,
    icon: <SiProgress />,
    title: "SEO Optimisation",
    des: "SEO optimization enhances online visibility, improving website rankings through strategic keyword targeting and quality content.",
  },
  {
    id: 4,
    icon: <FaMobile />,
    title: "Social Media Marketing",
    des: "Strategic social media marketing boosts brand visibility, engagement, and conversions through targeted content and analytics.",
  },
  {
    id: 5,
    icon: <SiAntdesign />,
    title: "UX Design",
    des: "UX design focuses on creating seamless, intuitive interactions for users, enhancing satisfaction and product effectiveness.",
  },
  {
    id: 6,
    icon: <FaGlobe />,
    title: "Graphic Design",
    des: "Graphic design blends creativity and communication to visually convey messages, enhancing brand identity and user experience.",
  },
];
